import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LucideIcon } from 'lucide-react';

export interface NavigationItemProps {
  path: string;
  label: string;
  icon: LucideIcon;
  isActive?: boolean;
  onClick?: () => void;
}

export const NavigationItem = ({
  path,
  label,
  icon: Icon,
  isActive: propIsActive,
  onClick,
}: NavigationItemProps) => {
  const location = useLocation();
  const isActive = propIsActive ?? location.pathname === path;

  return (
    <li>
      <Link
        to={path}
        onClick={onClick}
        className={`
          flex items-center gap-3 px-4 py-3 rounded-xl
          transition-all duration-200
          ${isActive
            ? 'bg-accent text-white shadow-md shadow-accent/20'
            : 'text-gray-700 hover:bg-gray-50 hover:text-accent'
          }
        `}
      >
        <Icon className="w-5 h-5" size={20} />
        <span className="font-medium">{label}</span>
      </Link>
    </li>
  );
};

